const styles = (theme) => ({
  root: {
    '& .CardContent': {
      paddingBottom: theme.spacing.unit * 3,
    },
  },
  cardContent: {
    paddingTop: theme.spacing.unit * 2,
  },
  turquoise: {
    '&&': {
      color: theme.palette.custom.maintenance,
    },
  },
  nonCollapsedGrid: {
    paddingBottom: theme.spacing.unit,
  },
  bold: {
    fontWeight: 500,
  },
  collapsedGrid: {
    paddingBottom: theme.spacing.unit,
  },
  detailsDivider: {
    '&:last-child': {
      display: 'none',
    },
  },
});

export default styles;
